import { types } from 'mobx-state-tree'

const ResourceTypeTemplateModel = types.model('ResourceTypeTemplateModel', {
  id: types.optional(types.number, 0),
  name: types.maybeNull(types.string),
})

export default ResourceTypeTemplateModel
